import React__default, { useRef, useEffect } from 'react';
import { useCurrentSrc } from '../../utils.js';
import { Square } from '../Square/index.js';
import styles from 'ui-components/ProductListMedia.scss';

var ProductListMedia = function ProductListMedia(_ref) {
  var className = _ref.className,
    _ref$product = _ref.product,
    name = _ref$product.name,
    _ref$product$attribut = _ref$product.attributes,
    tinyImage = _ref$product$attribut.tinyImage,
    smallImage = _ref$product$attribut.smallImage,
    mediumImage = _ref$product$attribut.mediumImage,
    largeImage = _ref$product$attribut.largeImage,
    _ref$lazyLoading = _ref.lazyLoading,
    lazyLoading = _ref$lazyLoading === void 0 ? true : _ref$lazyLoading,
    getCurrentImageSrc = _ref.getCurrentImageSrc;
  var imageRef = useRef();
  var defaultImage = tinyImage || smallImage || mediumImage || largeImage || {
    x1: "",
    x2: ""
  };
  var image = useCurrentSrc(imageRef, defaultImage.x1);
  useEffect(function () {
    if (typeof getCurrentImageSrc === "function") {
      getCurrentImageSrc(image);
    }
  }, [image, getCurrentImageSrc]);
  return /*#__PURE__*/React__default.createElement("picture", {
    className: className
  }, largeImage && /*#__PURE__*/React__default.createElement("source", {
    srcSet: largeImage.x1 + " 1x, " + largeImage.x2 + " 2x",
    media: "(min-width: " + styles.large + "px)"
  }), mediumImage && /*#__PURE__*/React__default.createElement("source", {
    srcSet: mediumImage.x1 + " 1x, " + mediumImage.x2 + " 2x",
    media: "(min-width: " + styles.medium + "px)"
  }), smallImage && /*#__PURE__*/React__default.createElement("source", {
    srcSet: smallImage.x1 + " 1x, " + smallImage.x2 + " 2x",
    media: "(min-width: " + styles.small + "px)"
  }), tinyImage && /*#__PURE__*/React__default.createElement("source", {
    srcSet: tinyImage.x1 + " 1x, " + tinyImage.x2 + " 2x",
    media: "(min-width: 0px)"
  }), /*#__PURE__*/React__default.createElement("img", {
    ref: imageRef,
    alt: name,
    src: image,
    className: styles.image,
    loading: lazyLoading === true ? "lazy" : "eager"
  }), /*#__PURE__*/React__default.createElement(Square, null));
};

export { ProductListMedia };
//# sourceMappingURL=index.js.map
